import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

import { NavigationEnd, Router } from '@angular/router';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { UtilityService } from '../services/utility.service';
import { MasterMOMService } from '../services/master-mom.service';
import { UserService } from '../services/user.service';
import Notiflix from "notiflix";
import { usermaster } from '../models/admin';
import { alert } from '../models/MOMForm';
import { Subscription } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminService } from '../services/admin.service';
import { pairText, Users } from '../models/users';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [ToastrUtilsService]
})
export class HeaderComponent implements OnInit {
  @ViewChild('templateFile', { static: false }) templateFile: TemplateRef<any>;
  modalRef: BsModalRef;
  subscription: Subscription;
  //New Site Work start
  public shouldShow = false;
  public SubmenuShow1 = false;
  public SubmenuShow2 = false;
  public SubmenuShow3 = false;
  public SubmenuShow4 = false;
  public SubmenuShow5 = false;
  public SubmenuShow6 = false;
  public SubmenuShow7 = false;
  public SubmenuShow8 = false;
  public SubmenuShow9 = false;
  public SubmenuShow10 = false;
  public SubmenuShow11 = false;
  public SubmenuShow12 = false;

  headerDynamicImage: string;
  isHeaderDewaLogo: boolean = false;

  isUser: boolean = false;

  animation = 'pulse';
  contentLoaded = false;
  searchText: string;
  login_UserID: any;
  alertCount: number;
  alertList: any = [];
  profilePicture: string = '/../../assets/img/user-default.png';
  userRole: number;
  noDataImage: string;
  count: number;
  strK1: string;
  strI1: string;
  //intervalId;
  constructor(public utilityService: UtilityService,
    private modalService: BsModalService,
    private toastr: ToastrUtilsService,
    public momMasterservice: MasterMOMService,
    private userService: UserService,
    public restApi: AdminService,
    private _router: Router) {
    this.subscription = this.userService.getProfileImage().subscribe(imgUrl => {
      if (imgUrl) {
        ;
        this.profilePicture = imgUrl.text;
        //console.log("Sub Profile pic", imgUrl.text);
      } else {
        // clear messages when empty message received
        this.profilePicture = '/../../assets/img/user-default.png';
      }
    });


  }


  ngOnInit() {
    console.log("header run")
    this.loadHeaderData();

    // Listen for route changes
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.loadHeaderData(); // Run your logic again whenever the URL changes
    });

    //this.document.body.classList.removeClass('Login');
    //New Site Work start


    // this.intervalId = setInterval(() => {
    //   this.animation = this.animation === 'pulse' ? 'progress-dark' : 'pulse';
    // }, 5000);

    //New Site Work end

  }

  loadHeaderData() {
    this.loginLoad();
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();
    this.userRole = Number(user.role);
    this.loadpairText();
    if (user == undefined || user.id <= 0) {
      //this.userService.logout();
      this._router.navigate(['/logintype']);
    }
    else {
      this.login_UserID = user.id;
      this.loadAlerts();
      this.loadUserInfo();
      this.isUser = true;
      setTimeout(() => {
        this.contentLoaded = true;
      }, 2000);
    }
  }

  storeToken() {
    ;
    let objusers = new Users;
    let users = this.userService.getUserInfo();
    objusers.userId = users.id;
    objusers.userName = users.username;
    //logging Logout details
    this.momMasterservice.SetTokenInfo_ByUserName(objusers).subscribe(
      data => {
      },
      error => {
      },
      () => {
      });
  }


  loginLoad() {
    if (this.userService.headerLogo != null && this.userService.headerLogo != undefined) {
      this.headerDynamicImage = this.userService.headerLogo;
    }
    else {
      var imageHeader = this.userService.getHeaderLogo();
      this.headerDynamicImage = imageHeader != null && imageHeader != undefined ? imageHeader : this.userService.dewaLogo;
    }
    this.subscription = this.userService.getheaderImage().subscribe(imgUrl => {

      var user = this.userService.getUserInfo();

      if (!user) this.loadHeaderData()

      if (imgUrl) {
        ;
        this.headerDynamicImage = '';
        this.isHeaderDewaLogo = imgUrl.text != '' && imgUrl.text != undefined && imgUrl.text != null ? true : false;
        let imageUno = imgUrl.imageUno != '' && imgUrl.imageUno != undefined && imgUrl.imageUno != null ? imgUrl.imageUno : 0;
        console.log("add meeting isHeaderDewaLogo", imgUrl);
        if (this.isHeaderDewaLogo) {
          if (imageUno == 1) {
            this.headerDynamicImage = this.userService.digitalxLogo;
          }
          else if (imageUno == 2) {
            this.headerDynamicImage = this.userService.digitalDewaLogo;
          }
          else if (imageUno == 3) {
            this.headerDynamicImage = this.userService.moroLogo;
          }
          else if (imageUno == 4) {
            this.headerDynamicImage = this.userService.infraxLogo;
          }
          else {
            this.headerDynamicImage = this.userService.dewaLogo;
          }
        }
        else {
          this.headerDynamicImage = this.userService.dewaLogo;
        }
        //console.log("Sub Profile pic", imgUrl.text);
      } else {
        // clear messages when empty message received
        this.headerDynamicImage = this.userService.dewaLogo;
      }
    },
      (error) => {
        this.headerDynamicImage = this.userService.dewaLogo;
        //Called when error

      }
    ).add(() => {
      this.headerDynamicImage = this.userService.dewaLogo;
      //Called when operation is complete (both success and error)

    });
  }


  loadpairText() {
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        let rtnData: pairText;
        rtnData = data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  logout_User() {
    this.userService.logout();
    this.storeToken();

    // setTimeout(() => {
    //   this._router.navigate(["/"]);
    // }, 300);
  }
  openModalnewMeeting(template1: TemplateRef<any>) {

    this.modalRef = this.modalService.show(template1, Object.assign({}, { class: 'gray modal-md modal-full' })
    );
  }
  CloseView() {
    let link: any = document.getElementById('hideAddTask');
    this.count = 0;
    link.classList.remove('show');
  }
  loadUserInfo() {
    // Notiflix.Loading.Standard('Please Wait...', '.pageloadcontainer');
    //Notiflix.Block.Dots('.pageloadcontainer');
    //this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 8;
    inpValue.startIndex = 0;
    inpValue.maxCount = 0;
    this.momMasterservice.getUserMasters(inpValue)
      .subscribe(data => {
        ;
        if (data != null && data != undefined) {
          console.log("userinformation", data);
          let dataItemList: any = [];
          dataItemList = data;
          //this.userInfoList = data[0];
          //this.model.displayNameEn = data[0].displayNameEn;
          //this.model.displayNameAr = data[0].displayNameAr;
          //this.model.firstname = data[0].firstname;
          //this.model.lastname = data[0].lastname;
          this.profilePicture = data[0].picture != null && data[0].picture != undefined && data[0].picture != '' ? data[0].picture : '/../../assets/img/user-default.png';
          //console.log("load Profile pic", this.profilePicture);
          //this.model.followUp = data[0].followUp;
        }
        else {
          //this.userInfoList = [];
        }
        // Notiflix.Block.Remove('.pageloadcontainer', 800);
      },
        (error) => {
          Notiflix.Loading.Remove();
          // this.spinner.hide();
        }
      ).add(() => {
        Notiflix.Loading.Remove();
        ///this.spinner.hide();
      });
  }
  toggleMenu() {
    // ;
    let link: any = document.getElementById('mainDiv');
    link.classList.toggle('mainsideMenu');
    //link.classList.toggle('sideMenuspace'); 

    setTimeout(() => {
      //if (this.userService.angularGrid)
      // this.userService.angularGrid.resizerService.resizeGrid();
    }, 500)

  }
  search() {

    var searchText = this.searchText;
    if (searchText != undefined && searchText.trim() != "") {

      this.searchText = '';
      this._router.navigate(['search'], { queryParams: { QText: btoa(searchText) } });
    }

  }
  loadAlerts() {



    let inpValue = new alert();
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 0;
    inpValue.startIndex = 1;
    inpValue.maxCount = 5;
    this.momMasterservice.getAlertList(inpValue)
      .subscribe((data: any) => {
        let dataList: any = [];
        dataList = data;
        this.alertList = dataList.slice(0, 5);
        this.alertCount = dataList.length;
        this.count = this.alertCount;
      },
        () => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });

  }
  markAsVisited() {

    let inpValue = new alert();
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 0;
    inpValue.startIndex = 1;
    inpValue.maxCount = 100;
    this.momMasterservice.markAsVisited(inpValue)
      .subscribe((data: any) => {

        this.alertCount = 0;


      },
        () => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });

  }

  loadValues(obj) {

    // this._router.navigate(['/view-page'], { queryParams: { QMId: objEncryptDecrypt.EncryptText(obj.genInfoUno), QMType: objEncryptDecrypt.EncryptText(obj.type) } });
  }
  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }
}
